var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.churches,"label":"Church"},on:{"input":_vm.onInput},model:{value:(_vm.church),callback:function ($$v) {_vm.church=$$v},expression:"church"}})}
var staticRenderFns = []

export { render, staticRenderFns }